module.exports = __webpack_public_path__ + "static/media/rekening_mandiri.72d35665.png";